// extracted by mini-css-extract-plugin
export default {"currentUser":"UserMenu_currentUser__ZacTw","details":"UserMenu_details__vQ4re"};